import React, {Component} from 'react';
import { connect } from 'react-redux';

import { t } from 'l10n';
import paths from 'paths';
import queryString from "query-string";

import '../../sass/scrollArea.scss';
import '../../sass/member/MemberMessage.scss';

import Loading from 'components/Loading';
import GenderIcon from 'components/GenderIcon';
import ProfileAvatar from 'components/ProfileAvatar';
import MessageHeader from 'components/message/MessageHeader';
import ModalBlacklist from '../../components/modals/ModalBlacklist';
import { Link, Redirect } from 'components/ReactRouterDomLocalized';
import MessageDialogAction from 'components/message/MessageDialogAction';
import MessageDialogConversation from 'components/message/MessageDialogConversation';

import { 
    clearDialogInMemory,
    getMemberMessageDialog,
    getNewMemberMessageDialog
} from 'reducers/memberMessageDialog';

import { actionFilterMemberMessage } from 'reducers/memberMessageList';

class MessageDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {
            onfocus: true,
            keyActive: false,
            mouseActive: false,
            scrollActive: false,
            positionBottom: null,
            modalBlacklist: false,
            readNewMessage: false,
            pendingMarkAsRead: false,
        };

        this.handleScroll = this.handleScroll.bind(this);
        this.handleKeyup = this.handleKeyup.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleMouseup = this.handleMouseup.bind(this);
        this.handleMousedown = this.handleMousedown.bind(this);
        this.setIntervarFetchData = this.setIntervarFetchData.bind(this);
    
        window.onfocus = () => this.setState({onfocus: true});
        window.onblur  = () => this.setState({onfocus: false});
    }

    fetchData(params) {
        const conversation_id = this.props.match.params.id;

        const reducerParams = {
            recipient_id: conversation_id,
            ...params
        };

        const query = conversation_id ? getMemberMessageDialog(reducerParams) : false;

        return query;
    }

    componentDidMount() {
        const { dispatch } = this.props;

        let action = this.fetchData();
        dispatch(action);

        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('keyup', this.handleKeyup);
        window.addEventListener('keydown', this.handleKeydown);
        window.addEventListener('mouseup', this.handleMouseup);
        window.addEventListener('mousedown', this.handleMousedown);

        this.interval = setInterval(this.setIntervarFetchData, 10000);
    }

    componentDidUpdate() {
        const {
            onfocus,
            scrollTop,
            keyActive,
            mouseActive,
            scrollActive,
            readNewMessage,
            positionBottom,
            pendingMarkAsRead
        } = this.state;
        const { unRead } = this.props.memberMessageDialog;

        const userActive = keyActive || mouseActive || scrollActive;
        onfocus && userActive && unRead && !pendingMarkAsRead && positionBottom ? this.markAsRead() : false;

        readNewMessage ? this.setState({readNewMessage: false}) : false;
    }

    componentWillUnmount() {
        const { dispatch } = this.props;

        let action = clearDialogInMemory();
        dispatch(action);

        clearInterval(this.interval);

        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('keyup', this.handleKeyup);
        window.removeEventListener('keydown', this.handleKeydown);
        window.removeEventListener('mouseup', this.handleMouseup);
        window.removeEventListener('mousedown', this.handleMousedown);
    }

    setIntervarFetchData() {
        const {
            scrollHeight,
            positionBottom
        } = this.state;
        const { dispatch } = this.props;
        const conversation_id = this.props.match.params.id;

        const reducerParams = {
            recipient_id: conversation_id,
        };

        let action = getNewMemberMessageDialog(reducerParams);
        dispatch(action);

        action.promise.then(() => { 
            positionBottom ? window.scrollTo(0 , scrollHeight) : false; 
            this.setState({disableScrollActive: true});
        })
    }

    handleKeyup(e) { this.setState({keyActive: false}); }
    handleKeydown(e) { this.setState({keyActive: true}); }
    handleMouseup(e) { this.setState({mouseActive: false}); }
    handleMousedown(e) { this.setState({mouseActive: true}); }

    handleScroll(e) {
        const {
            count,
            offset,
            unRead,
        } = this.props.memberMessageDialog;

        const { 
            oldScrollTop,
            pendingScroll, 
            disableScrollActive
        } = this.state;

        const { 
            scrollTop,
            scrollHeight
        } = e.target.scrollingElement;
        let innerHeight = window.innerHeight;
        const bottom = scrollTop + innerHeight == scrollHeight;
 

        this.setState({
            positionBottom: bottom,
            oldScrollTop: scrollTop,
            scrollHeight: scrollHeight,
            scrollActive: !disableScrollActive && scrollTop !== oldScrollTop,
        });

        if(scrollTop !== 0 && scrollTop < 50 && offset !== count && !pendingScroll) {

            const { dispatch } = this.props;

            const params = {
                offset: offset
            };

            this.setState({pendingScroll: true})

            let action = this.fetchData(params);
            dispatch(action);
                    
            action.promise
                .then(() => {
                    window.scrollTo(0 , e.target.scrollingElement.scrollHeight - scrollHeight);
                    this.setState({pendingScroll: false});
                })
                .catch((e) => this.setState({pendingScroll: false}));
        }

        this.setState({
            scrollActive: false,
            disableScrollActive: bottom
        });
    }

    markAsRead() {
        const { dispatch } = this.props;
        const conversation_id = this.props.match.params.id;

        const reducerParams = {
            ids: conversation_id,
            action: 'read',
            inDialogue: true,
        };

        this.setState({pendingMarkAsRead: true});

        let action = actionFilterMemberMessage(reducerParams);
        dispatch(action);

        action.promise
            .then(() => {
                this.setState({
                    readNewMessage: true,
                    pendingMarkAsRead: false,
                });
            })
            .catch((e) => this.setState({pendingMarkAsRead: false}));
    }

    render() {
        if(!this.props.memberMessageDialog.recipient) return <Loading centered/>;

        const {
            unRead,
            status,
            message,
            newCount,
            recipient,
            totalCount,
            trashCount,
            messageList
        } = this.props.memberMessageDialog;

        const { 
            pendingScroll,
            modalBlacklist,
            positionBottom,
            readNewMessage,
        } = this.state;

        return (
            <div className="index-message">
                <MessageHeader
                    newCount={newCount}
                    trashCount={trashCount}
                    messagesCount={totalCount}
                    showForm={false}
                    title={t('Conversation')}
                />

                <div className="top">
                    <Link to={paths.memberMessageListMessages.path} className="back-message">{t('Back to Messages list')}</Link>
                    <div className="top-info-user">
                        <Link to={recipient.user.profile_url} className="user-info">
                            <ProfileAvatar user={recipient.user} />
                            <div className="name-user">
                                <GenderIcon user={recipient.user} />
                                <p>{recipient.user.nick}</p>
                            </div>
                        </Link>
                        <MessageDialogAction 
                            recipient={recipient}
                            showModalBlacklist={() => this.setState({modalBlacklist: true})}
                        />
                    </div>
                    {pendingScroll ? <Loading /> : null}
                </div>
                <MessageDialogConversation
                    unRead={unRead}
                    readNewMessage={readNewMessage}
                    positionBottom={positionBottom}
                    recipient={recipient}
                    messageList={messageList}
                    enableScrollActive={() => this.setState({scrollActive: true})}
                    messageError={status && status !== 'success' ? message : ''}
                />
                <ModalBlacklist
                    show={modalBlacklist}
                    closeFn={() => this.setState({modalBlacklist: false})}
                    blacklistedByMe={recipient.blacklistedByMe}
                    user={recipient.user}
                />
            </div>
        )
    }
}

export default connect(
    state => ({
        memberMessageList: state.memberMessageList,
        memberMessageDialog: state.memberMessageDialog
    }), 
    null
)(MessageDialog)


// WEBPACK FOOTER //
// ./src/containers/member/MessageDialog.js